import IndiceRevisionFormController from './indice.revision.form.controller';

export default {
    template: require('./indice.revision.form.html'),
    controller: IndiceRevisionFormController
};
